// src/TelaInicial.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { FaKey, FaUsers, FaUtensils, FaCashRegister, FaMoneyBill, FaChartBar, FaHome, FaSuse, FaCalculator } from 'react-icons/fa';
import NotificacoesButtons from '../components/NotificacoesButtons';
import ButtonSquad from '../components/ButtonSquad';

const TelaInicial = () => {
  const navigate = useNavigate();
  const [colunas, setColunas] = React.useState(getGridColumns());
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 900);
  const [notificacoes, setNotificacoes] = React.useState(() => {
    const salvas = localStorage.getItem('notificacoes');
    return salvas ? JSON.parse(salvas) : [];
  });
  const user = JSON.parse(localStorage.getItem('user'));
 
  React.useEffect(() => {
    const handleResize = () => {
      setColunas(getGridColumns());
      setIsMobile(window.innerWidth < 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${colunas}, 1fr)`,
    gap: isMobile ? '20px' : '30px',
    width: '100%',
    maxWidth: '900px',
    margin: isMobile ? '0 auto' : '0',
    padding: isMobile ? '0 20px' : '0 40px',
    justifyContent: isMobile ? 'center' : 'start',
  };

  // const botoes = [
  //   { texto: 'Permissões', rota: '/colaboradores', icon: FaKey },
  //   { texto: 'Associados', rota: '/associados', icon: FaUsers },
  //   // { texto: 'Financeiro', rota: '/financeiroclube', icon: FaMoneyBill },
  //   // { texto: 'Cardápio', rota: '/cardapio', icon: FaUtensils },
  //   { texto: 'Saldo Lanchonete', rota: '/saldolanchonete', icon: FaCalculator },
  //   { texto: 'Serviços Lanchonete', rota: '/servicoslanchonete', icon: FaCashRegister },
  //   // { texto: 'Relatórios', rota: '/relatorios', icon: FaChartBar },
  // ];
const botoes = [
  { 
    texto: 'Permissões', 
    rota: '/colaboradores', 
    icon: FaKey,
    gradient: 'linear-gradient(135deg, #1A3B7D 0%, #2D4B8C 100%)' // Azul principal
  },
  { 
    texto: 'Associados', 
    rota: '/associados', 
    icon: FaUsers,
    gradient: 'linear-gradient(135deg, #2E8B57 0%, #3DA56C 100%)' // Verde escuro
  },
  { 
    texto: 'Saldo Lanchonete', 
    rota: '/saldolanchonete', 
    icon: FaCalculator,
    gradient: 'linear-gradient(135deg, #DAA520 0%, #E8B939 100%)' // Dourado
  },
  { 
    texto: 'Serviços Lanchonete', 
    rota: '/servicoslanchonete', 
    icon: FaCashRegister,
    gradient: 'linear-gradient(135deg, #FF6B4A 0%, #FF8C69 100%)'

  },
];

 return (
  <Layout title={`Bem-vindo(a) ${user?.name || ''}`} icon={FaHome}>
    
      {/* Componente de Notificações */}
      <NotificacoesButtons 
        notificacoes={notificacoes} 
        setNotificacoes={setNotificacoes} 
      />
    
      {/* Grade de Botões Principal */}
      <div style={styles.gridContainer}>
        <div style={gridStyle}>
          {botoes.map((botao, index) => (
            <ButtonSquad
              key={index}
              texto={botao.texto}
              icon={botao.icon}
              isMobile={isMobile}
              onClick={() => navigate(botao.rota)}
              gradient={botao.gradient} // Adicione esta linha
            />
          ))}
        </div>
      </div>
    </Layout>
  );
};



const getGridColumns = () => {
  const largura = window.innerWidth;
  if (largura < 600) return 2;
  if (largura < 900) return 2;
  return 3;
};

const styles = {
  notificacaoContainer: {
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
    padding: '0 20px',
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  notificacaoButton: {
      backgroundColor: '#1A3B7D', // Azul principal
      background: 'linear-gradient(135deg, #1A3B7D 0%, #2D4B8C 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '25px',
      padding: '12px 25px',
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      boxShadow: '0 4px 8px rgba(26, 59, 125, 0.3)',
      transition: 'all 0.3s ease',
        ':hover': {
        background: 'linear-gradient(135deg, #14306D 0%, #253D7A 100%)',
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 12px rgba(26, 59, 125, 0.4)',
    },
    ':active': {
      transform: 'translateY(0)',
    }
  },
  gridContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  },
  card: {
    backgroundColor: '#fff',
    border: 'none',
    borderRadius: '12px',
    padding: '20px',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '16px',
    fontWeight: '500',
    color: '#1A3B7D',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    textAlign: 'center',
    transition: 'transform 0.2s, box-shadow 0.2s',
    ':hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)',
    },
  },
  label: {
    marginTop: '10px',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '12px',
    width: '90%',
    maxWidth: '500px',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.2)',
  },
  modalTitle: {
    color: '#1A3B7D',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Montserrat, sans-serif',
  },
  notificacaoInput: {
    width: '100%',
    padding: '15px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '16px',
    marginBottom: '20px',
    resize: 'vertical',
    minHeight: '120px',
    ':focus': {
      outline: 'none',
      borderColor: '#1A3B7D',
      boxShadow: '0 0 0 2px rgba(26, 59, 125, 0.2)',
    },
  },
  modalButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  modalButtonCancelar: {
    padding: '10px 20px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    backgroundColor: 'white',
    color: '#333',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    ':hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  modalButtonEnviar: {
    padding: '10px 20px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#1A3B7D',
    color: 'white',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: '500',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    transition: 'background-color 0.2s',
    ':hover': {
      backgroundColor: '#14306D',
    },
    ':disabled': {
      backgroundColor: '#cccccc',
      cursor: 'not-allowed',
    },
  },
};

export default TelaInicial;